export var views = {
  default: 'default',
  success: 'success',
  warning: 'warning',
  error: 'error'
};
export var themes = {
  b2c: 'b2c',
  b2b: 'b2b'
};